import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-screens-component',
  templateUrl: './screens.component.html',
  styleUrls: ['./screens.component.css']
})
export class ScreensComponent implements OnInit {

  @Output() closeEvent = new EventEmitter();
  screenshotIndex = 1;

  constructor() { }

  ngOnInit() {
  }

  nextScreenshot(event) {
    event.stopPropagation();
    if (this.screenshotIndex === 3) {
      this.screenshotIndex = 1;
    } else {
      this.screenshotIndex++;
    }
  }

  previousScreenshot(event) {
    event.stopPropagation();
    if (this.screenshotIndex === 1) {
      this.screenshotIndex = 3;
    } else {
      this.screenshotIndex--;
    }
  }

  close() {
    this.closeEvent.emit();
  }
}
